// @mui
import { useMediaQuery } from '@mui/material';

// ----------------------------------------------------------------------

export default function useStageMode() {
  const reduced = useMediaQuery('(prefers-reduced-motion: reduce)', { noSsr: true });

  const wide = useMediaQuery('(min-width: 900px)', { noSsr: true });

  const tall = useMediaQuery('(min-height: 680px)', { noSsr: true });

  const finePointer = useMediaQuery('(hover: hover) and (pointer: fine)', { noSsr: true });

  return { heroPinned: wide && tall && !reduced, reduced, finePointer };
}
